module.exports = __webpack_public_path__ + "ce9ba8842cdd59155335388b5c57b9cf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/17_E3.mp3
// module id = 57
// module chunks = 0